import { LeadEditor, type LeadLike } from './LeadEditor';

/**
 * محرّر العميل — هو محرّر «ملف العميل» الموحَّد نفسه.
 *
 * كان نموذجًا ثانيًا بحقوله وترتيبه وأعطاله المستقلّة، فافترق الملفّان:
 * ما يُضاف هنا لا يظهر هناك، وما يُحوَّل من عميلٍ محتمل يفقد نصف
 * حقوله لأن النموذج لا يعرفها. صار غلافًا على النموذج الواحد —
 * الاختلاف الوحيد أن العميل نوعُه (فرد/شركة) بدل مسار التأهيل،
 * وخصوصياته (القانوني والضريبي والموقع) مكان «الشركة».
 */
export function AccountEditor({
  account,
  onClose,
}: {
  account?: LeadLike;
  onClose: () => void;
}) {
  return <LeadEditor entity="account" lead={account} onClose={onClose} />;
}
